import { render, staticRenderFns } from "./esimMailRecord.vue?vue&type=template&id=6c08ef36&scoped=true&"
import script from "./esimMailRecord.vue?vue&type=script&lang=js&"
export * from "./esimMailRecord.vue?vue&type=script&lang=js&"
import style0 from "./esimMailRecord.vue?vue&type=style&index=0&id=6c08ef36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08ef36",
  null
  
)

export default component.exports